import { ViewChild, Component, OnInit, Input, EventEmitter, Output, ElementRef } from '@angular/core';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent {

  @Input()
  width: number;

  @Input()
  modalBackground: boolean;

  @Input()
  position: string; // position-middle

  @Output()
  close: EventEmitter<void> = new EventEmitter();
  
  private _open: boolean;

  get open(): boolean {
    return this._open;
  }

  @Input()
  title: string;

  @Input()
  set open(open: boolean) {
    this._open = open;
  }

  closeModal() {
    this.close.emit();
    // this._open = false;
  }

}

// link to click outside possibility: https://stackoverflow.com/a/51152404/3086147